module.exports = __webpack_public_path__ + "static/img/guarana.005fd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/guarana.png
// module id = uMus
// module chunks = 0